// extracted by mini-css-extract-plugin
export default {"root":"iXJ0r8","count":"eIBPr4","complaintTab":"M_YmBA"};